<template>
  <Row class="searchnav">
    <Col span="6" class="account">
      <label :style="{marginRight:'10px', fontSize:'14px'}">{{$t('label.w159')}}</label>
      <Select v-model="type" @on-change="change">
        <Option value="-1">{{$t('option.w33')}}</Option>
        <Option value="0">{{$t('option.w34')}}</Option>
        <Option value="1">{{$t('option.w35')}}</Option>
        <Option value="2">{{$t('option.w71')}}</Option>
      </Select>
    </Col>
    <Col span="7" class="type">
      <label :style="{marginRight:'10px',fontSize:'14px'}">{{$t('label.w129')}}</label>
      <Select
        v-model="purpose"
        @on-change="change"
        multiple
        :max-tag-count="2"
        :max-tag-placeholder="maxTagPlaceholder"
        class="select"
      >
        <!-- <Option value="-1">{{$t('option.w33')}}</Option> -->
        <Option :value="v.Id" :key="v.Id" v-for="v in purposeList">{{v.Name}}</Option>
      </Select>
    </Col>
    <Col span="11" class="timeselect">
      <label :style="{marginRight:'10px'}">{{$t('label.w123')}}</label>
      <DatePicker type="date" v-model="start" :placeholder="$t('pl.p12')" @on-change="change"></DatePicker>
      <span>—</span>
      <DatePicker type="date" v-model="end" :placeholder="$t('pl.p19')" @on-change="change"></DatePicker>
    </Col>
  </Row>
</template>

<script>
import { getOnce } from "@/libs/axios";
export default {
  data() {
    return {
      type: "-1",
      purpose: [],
      start: "",
      end: "",
      purposeList: []
    };
  },
  methods: {
    change() {
      let v = {};
      if (this.type != "-1") v.type = this.type;
      if (this.purpose.length > 0) {
        v.purpose = this.purpose.join(",");
      }
      if (this.start) v.start = this.start;
      if (this.end) v.end = this.end;
      console.log(v);
      this.$emit("change", v);
    },
    maxTagPlaceholder(num) {
      return "+" + num;
    }
  },
  mounted() {
    getOnce("/Member/RZJFund/InvoicePurposeList").then(res => {
      console.log(res);
      if (res.err) return;
      this.purposeList = res;
    });
  }
};
</script>

<style lang="less" scoped>
.searchnav {
  margin-top: 30px;
  .ivu-select {
    color: #232325;
    font-weight: 500;
    width: 240px;
    /deep/.ivu-select-selection {
      background: #fff;
    }
  }
  .type {
    padding-left: 10px;
    .select {
      width: 290px;
      /deep/.ivu-tag {
        height: 32px !important;
        line-height: 32px !important;
      }
    }
  }
  .timeselect {
    padding-left: 20px;
    .ivu-date-picker {
      /deep/.ivu-input {
        background: #fff;
      }
    }
    span {
      display: inline-block;
      font-weight: 500;
      margin: 10px;
    }
  }
}
</style>
